var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-btn',{attrs:{"rounded":"","color":"primary","dark":""}},[_vm._v("Rounded Button")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }